import { render, staticRenderFns } from "./CorpoEmailCartao.vue?vue&type=template&id=18b15ef0&scoped=true"
import script from "./CorpoEmailCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./CorpoEmailCartao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b15ef0",
  null
  
)

export default component.exports